const defaultHeight = '10.438rem';
document.addEventListener('DOMContentLoaded', function () {
  // Wait for the DOM content to be fully loaded

  // Get all elements with the specified class
  const elements = document.querySelectorAll('slider-component [data-column="2"] .multicolumn-card__info');

  if (elements) {
    // Iterate over each element and attach a click event listener
    elements.forEach(function (element) {
      element.addEventListener('click', function (event) {
        toggleContent();
      });
    });
  }
});

function toggleContent() {
  const ele = document.querySelector('slider-component [data-column="2"] .multicolumn-card__info');
  if (ele) {
    // Toggle the visibility of the toggleDiv
    if (window.innerWidth > 1023) {
      if (ele.classList.contains('hideContent')) {
        ele.classList.remove('hideContent');
      }
    } else {
      ele.classList.toggle('hideContent');
      if (ele.classList.contains('hideContent')) {
        const findEle = ele.querySelector('.rte');
        if (findEle) findEle.style.height = 'auto';
      } else {
        const findEle = ele.querySelector('.rte');
        if (findEle) findEle.style.height = defaultHeight;
      }
    }
  }
}
